<app-entity-list
  title="Компетенції"
  [columns]="columns()"
  [data]="competences$ | async"
  [totalItems]="totalItems$ | async"
  [pageSize]="pageSize()"
  [pageIndex]="pageIndex()"
  [loading]="loading()"
  [customRowActions]="customRowActions"
  [endRowActions]="endRowActions"
  [showDelete]="showDelete"
  [rowClass]="rowClass"
  (pageChange)="onPageChange($event)"
  (sortChange)="onSortChange($event)"
  (searchChange)="onSearch($event)"
  (action)="onAction($event)"
>
  <div appFilters class="competences-filters">
    <mat-form-field appearance="outline" class="filter-field">
      <mat-label>Статус</mat-label>
      <mat-select multiple [disabled]="candidatesMode()" (selectionChange)="onStatusFilter($event.value)">
        @for (option of statusOptions; track option.value) {
          <mat-option [value]="option.value">{{ option.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-field">
      <mat-label>Тип</mat-label>
      <mat-select multiple [disabled]="candidatesMode()" (selectionChange)="onKindFilter($event.value)">
        @for (option of kindOptions; track option.value) {
          <mat-option [value]="option.value">{{ option.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <div class="filter-toggles">
      <mat-checkbox (change)="onCandidatesModeChange($event.checked)">Кандидати на злиття</mat-checkbox>
    </div>

    @if (loadFailed()) {
      <p class="load-error">Не вдалося завантажити компетенції. Змініть фільтр або повторіть пошук.</p>
    }
  </div>
</app-entity-list>
